import 'react-phone-number-input/style.css';
import cx from 'classnames';
import PhoneInput from 'react-phone-number-input';
import {createRef} from 'react';
import type {ComponentProps, FC} from 'react';

interface FormPhoneFieldProps extends ComponentProps<'input'> {
  readonly field?: ComponentProps<'input'>;
}

const FormPhoneField: FC<FormPhoneFieldProps> = ({className, field, ...props}) => {
  const ref = createRef<HTMLInputElement>();
  const handleChange = (value: string) => {
    if (!!field) {
      field?.onChange?.call(ref, {
        target: {name: field.name ?? '', value: value?.startsWith('+') ? value : `+${value}`},
      } as any);
    } else {
      props.onChange?.call(ref, {
        target: {...props, value: value?.startsWith('+') ? value : `+${value}`},
      } as any);
    }
  };
  return (
    <PhoneInput
      {...props}
      {...((field || {}) as any)}
      ref={ref}
      onChange={handleChange}
      style={{input: {backgroundColor: 'transparent'}}}
      className={cx('flex-1 p-3 pl-1 m-0 phone-number-input', className)}
      dir="ltr"
    />
  );
};

export default FormPhoneField;
